import { IAPIItemBreakDownDataModel } from "../interfaces";

 
export class ItemBreakDownGraphModel {
    product: number;
    service: number;
    membership: number;
    donation: number;
    constructor(data?: Partial<ItemBreakDownGraphModel>) {
        this.product = data?.product || 0;
        this.service = data?.service || 0;
        this.membership = data?.membership || 0;
        this.donation = data?.donation || 0;
    }

    static deserializeAPIModel(data: IAPIItemBreakDownDataModel): ItemBreakDownGraphModel {
        const mappedData: Partial<ItemBreakDownGraphModel> = {
            product: data.product,
            service: data.service,
            membership: data.membership,
            donation: data.donation,
        };
        return new ItemBreakDownGraphModel(mappedData);
    }
}
